module.exports = __webpack_public_path__ + "img/gcq.6c0f748b.png";